import React from 'react';
import {
  List,
  BulkDeleteWithConfirmButton,
  Datagrid,
  TextField,
  FunctionField,
  Filter,
  TextInput,
  DateInput
} from 'react-admin';

const ProjectRequestsFilter = (props) => (
  <Filter {...props}>
    <DateInput source="startDate" alwaysOn />
    <DateInput source="endDate" alwaysOn />
    <TextInput label="Customer Name" source="customerName" alwaysOn />
    <TextInput label="Service Name" source="serviceName" alwaysOn />
    <TextInput label="Service Code" source="serviceCode" />
    <TextInput label="Mobile" source="mobileNumber" alwaysOn />
    <TextInput label="Approved Vendor" source="approvedVendorId" />
    <TextInput label="Status" source="status" alwaysOn />
    <TextInput label="Address" source="address" />
    <TextInput label="LocalBody" source="localBody" />
    <TextInput label="District" source="district" />
    <TextInput label="State" source="state" />
    <TextInput label="Pincode" source="pincode" />
    <TextInput label="AmountToBePaid" source="amountToBePaid" />
    <TextInput label="AmountPaid" source="amountPaid" />
    <TextInput label="BalanceAmount" source="balanceAmount" />
    <TextInput label="CreatedAt" source="createdAt" />
  </Filter>
);

const rowClick = (id, basePath, record) => {
  if (record.id === 0) {
    return 'show';
  }
  return 'edit';
};

const role = localStorage.getItem('role');
const ProjectRequestsBulkActionButtons = (props) => <BulkDeleteWithConfirmButton {...props} disabled={role !== 'admin'} />;

export const ProjectRequestsList = (props) => (
  <List
    title="Project Requests"
    sort={{ field: 'id', order: 'DESC' }}
    {...props}
    filters={<ProjectRequestsFilter />}
    bulkActionButtons={<ProjectRequestsBulkActionButtons />}
  >
    <Datagrid rowClick={rowClick}>
      <TextField source="customerName" />
      <TextField source="mobileNumber" label="Mobile" />
      <TextField source="serviceCode" />
      <TextField source="serviceName" />
      <TextField source="description" />
      <TextField source="address" />
      <TextField source="localBody" />
      <TextField source="district" />
      <TextField source="state" />
      <TextField source="pincode" />
      <TextField source="localContactNumber" />
      <TextField source="amountToBePaid" label="Total Amount" />
      <FunctionField
        label="Amount Paid"
        render={(record) => {
          const isApproved = record.isAdminApproved === true || record.isAdminApproved === 'true';
          const agreed = parseFloat(record.amountToBePaid) || 0;
          let rawPaid = parseFloat(record.amountPaid) || 0;
          let rawReq = parseFloat(record.amountRequested || 0);
          let paid = rawPaid;
          if (!isApproved && rawReq === 0 && rawPaid > 0) {
            paid = 0;
          }
          if (agreed > 0 && paid > agreed) {
            paid = agreed;
          }
          return `₹${paid.toLocaleString('en-IN')}`;
        }}
      />
      <FunctionField
        label="Balance Amount"
        render={(record) => {
          const isApproved = record.isAdminApproved === true || record.isAdminApproved === 'true';
          const agreed = parseFloat(record.amountToBePaid) || 0;
          let rawPaid = parseFloat(record.amountPaid) || 0;
          let rawReq = parseFloat(record.amountRequested || 0);
          let paid = rawPaid;
          if (!isApproved && rawReq === 0 && rawPaid > 0) {
            paid = 0;
          }
          if (agreed > 0 && paid > agreed) {
            paid = agreed;
          }
          const bal = Math.max(0, agreed - paid);
          return `₹${bal.toLocaleString('en-IN')}`;
        }}
      />
      <FunctionField
        label="Amount Requested for Approval"
        render={(record) => {
          const isApproved = record.isAdminApproved === true || record.isAdminApproved === 'true';
          if (isApproved) return '₹0';
          let reqAmt = parseFloat(record.amountRequested || 0);
          let rawPaid = parseFloat(record.amountPaid) || 0;
          if (reqAmt === 0 && rawPaid > 0) {
            reqAmt = rawPaid;
          }
          return `₹${reqAmt.toLocaleString('en-IN')}`;
        }}
      />
      <FunctionField
        label="Approved Vendor ID"
        render={(record) => (record && record.approvedVendorId ? String(record.approvedVendorId).toUpperCase() : '')}
      />
      <TextField source="status" />
      <TextField source="createdAt" />
    </Datagrid>
  </List>
);

export default ProjectRequestsList;
